import React from 'react'

export default class EventTypesComboBox extends React.Component {
    constructor(){
        super();
        this.onChange = this.onChange.bind(this);
        this.selected = this.selected.bind(this);
    }
    selected(value) {
        console.log('value ' + value);
        return value === this.props.value ?  "selected":"false";
    }
    onChange(event) {
        this.props.onChange(event.target.value);
    }
    render(){
        return <div>
        <select onChange={this.onChange} value={this.props.value}>
        <option value={""} ></option>
        {this.props.eventTypes.map(eventType => (
            <option value={eventType.eventTypeId}  >{eventType.typeName}</option>
        ))}
        </select>
        </div>

    }
}


// WEBPACK FOOTER //
// ./src/EventTypesComboBox.js